export const INELIGIBLE_ACCOUNT_REDIRECT_URL =
  "https://www.capitalone.com/credit-cards/travel-and-miles/";
export const BAD_STATUS_REDIRECT_URL =
  "https://www.capitalone.com/support-center/contact-us";
